__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-host/v2_0_2421/";